import { ONE_TRUST_TOGGLE } from '@shared-components-web/constants';
import {
	resolveEntryLink,
	ResolveEntryLinkArgs,
} from '@shared-components-web/utils/resolveButtonEntryLink/resolveButtonEntryLink';
import {
	AdFooterNavigationGroupsCollection,
	FooterNavigationGroupNavigationLinksForGroupItem,
	Maybe,
	NavigationLink,
	Page,
} from '@src/lib/__generated/contentful/sdk';

export const isNavLink = (link: unknown): link is NavigationLink => {
	return typeof link === 'object' && link !== null && 'externalUrl' in link;
};

export const isOneTrustLink = (navigationLink: NavigationLink | null) => {
	return navigationLink && isNavLink(navigationLink) && navigationLink.externalUrl?.includes(ONE_TRUST_TOGGLE);
};

export function isPageLink(item?: Maybe<FooterNavigationGroupNavigationLinksForGroupItem | Page>): item is Page {
	if (!item) return false;

	return item.__typename === 'Page';
}

export function resolveLinkTitle(item?: Maybe<FooterNavigationGroupNavigationLinksForGroupItem> | Maybe<Page>) {
	if (!item) return '';

	if (isNavLink(item)) {
		if (item.isInternal && item.pageData && item.pageData.__typename === 'Page') {
			return item.pageData.breadcrumbTitle ?? item.pageData.title ?? '';
		}
		return item.linkText ?? '';
	} else if (isPageLink(item)) {
		return item.breadcrumbTitle ?? item.title ?? '';
	}

	return '';
}

export function resolveLinkUrl(
	item?: Maybe<FooterNavigationGroupNavigationLinksForGroupItem | Page>,
	contextData?: Partial<ResolveEntryLinkArgs>
) {
	const { config, officeInfo, officeLocationInfo } = contextData || {};
	if (!item) return '#';

	if (isNavLink(item)) {
		if (item.isInternal && item.pageData) {
			return resolveEntryLink({
				path: item.pageData?.path ?? '',
				typeName: item.pageData?.__typename as string,
				config,
				officeInfo,
				officeLocationInfo,
			} as ResolveEntryLinkArgs);
		}
		if (item.externalUrl?.includes(ONE_TRUST_TOGGLE)) {
			return '#';
		}
		return item.externalUrl ?? '#';
	} else if (isPageLink(item)) {
		return item.path ?? '#';
	}

	return '#';
}

export function resolveLinkImage(item?: Maybe<FooterNavigationGroupNavigationLinksForGroupItem | Page>) {
	if (!item) return null;

	if (isNavLink(item) && item.linkIcon) {
		return item.linkIcon;
	} else if (isPageLink(item) && item.image) {
		return item.image;
	}

	return null;
}

export function findCompanyGroup(navigationGroupItems?: Maybe<AdFooterNavigationGroupsCollection['items']>) {
	if (!navigationGroupItems) return null;

	return navigationGroupItems.find((group) => {
		const linkTitle = resolveLinkTitle(group?.navigationGroupLink);

		return linkTitle === 'Company';
	});
}
